import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Row, Col } from 'reactstrap';
import { Breadcrumbs } from 'site-modules/shared/components/breadcrumbs/breadcrumbs';
import { CustomHeroWrapper } from 'client/site-modules/shared/components/custom-hero-wrapper/custom-hero-wrapper';

export function CalculatorHeader({
  breadcrumbs,
  header,
  subheader,
  title = '',
  isHeroTitle = false,
  hideSeparator = false,
}) {
  const calculatorTitle = title && <h2 className="heading-3 mb-1">{title}</h2>;

  return (
    <Row>
      <Col xs={12} lg={8}>
        <Breadcrumbs data={breadcrumbs} className="ps-0 mb-1_5" />
        <h1 className="heading-2">{header}</h1>
        <CustomHeroWrapper>
          <p className={classNames('text-gray-darker', { 'mb-2': hideSeparator })}>{subheader}</p>
          {!hideSeparator && <hr className="mt-1_5 mb-2" />}
          {isHeroTitle && calculatorTitle}
        </CustomHeroWrapper>
        {!isHeroTitle && calculatorTitle}
      </Col>
    </Row>
  );
}

CalculatorHeader.propTypes = {
  breadcrumbs: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  header: PropTypes.string.isRequired,
  subheader: PropTypes.string.isRequired,
  title: PropTypes.string,
  isHeroTitle: PropTypes.bool,
  hideSeparator: PropTypes.bool,
};
